export enum Type {
    public = 'public',
    admin = 'admin',
    none = 'none'
}